import { SectionContainer } from "../atoms/containers/ContentContainers";
import { SellarisContent } from "../molecules/sellaris_content/SellarisContent";

export function Sellaris() {
	return (
		<SectionContainer id="sellaris" variant="dark" className="sellarisSection">
			<SellarisContent />
		</SectionContainer>
	);
}
